import { ObservableMap } from 'mobx';
import type { Signature } from '../store/schema/SignatureStore';

export default function getDefaultSignatureStore() {
    return {
        legacySignature: {
            html: null,
            txt: null,
        },
        roamingSignatureMap: new ObservableMap<string, Signature>(),
        defaultSignatureName: '',
        defaultReplySignatureName: '',
    };
}
